import { useContext, useEffect, useState } from 'react';
import AccountContext from '@/components/Accounts/AccountContext';
import useFetchPartnerAccounts from './useFetchPartnerAccounts';

/**
 * Returns the bearer token for the given accountId.
 * Uses AccountContext when the account is already loaded (e.g. navigated from the
 * accounts list). Falls back to fetching the account by VopayAccountID when the page is
 * loaded directly (e.g. deep-link or paginated list didn't include this account).
 */
const useAccountBearer = (accountId: string): string => {
  const { details } = useContext(AccountContext);
  const [token, setToken] = useState(details[accountId]?.token ?? '');
  const [accountsResponse, fetchAccount] = useFetchPartnerAccounts({});

  useEffect(() => {
    if (!token && accountId) {
      fetchAccount({ VopayAccountID: accountId, Limit: 1 });
    }
  }, [accountId]);

  useEffect(() => {
    const fetchedToken = accountsResponse?.accountDetails?.[accountId]?.token;
    if (fetchedToken) {
      setToken(fetchedToken);
    }
  }, [accountsResponse]);

  return token;
};

export default useAccountBearer;
